var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickRace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,5 H14 V43 H10 Z",
    fill: "#FFD000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14,8 H39 V28 H14 Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,8 H26 V18 H14 Z M27,18 H39 V28 H27 Z",
    fill: "#0D0D12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,8 H39 V18 H27 Z M14,18 H26 V28 H14 Z",
    fill: "#7C1CFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37,31 A6,6 0,1 0,37,43 A6,6 0,1 0,37,31",
    fill: "#00D4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37,33 A4,4 0,1 0,37,41 A4,4 0,1 0,37,33",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickRace);
export default __webpack_public_path__ + "static/media/quick-race.3d86042c8865566d21cd140c2c6ef77a.svg";
export { ForwardRef as ReactComponent };